import React from "react";
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/material";
import { styled } from "@mui/system";

export const TextareaAutosize = styled(BaseTextareaAutosize)(
  {}
) as React.ElementType;
